import * as R from 'ramda'

export const GoodsStatusText = {
  OFF_SHELVES: '未上架',
  ON_SHELVES: '已上架'
}

export function statusCodes () {
  return R.keys(GoodsStatusText)
}
export function statusOptions () {
  return R.values(GoodsStatusText)
}
